import React from "react"
import { Route, Redirect } from "react-router-dom"
import { useAuth } from "../src/components/firebase/AuthContext"

//import { toast } from 'react-toastify';
//import 'react-toastify/dist/ReactToastify.css';
//toast.configure()

export default function PrivateRoute({ component: Component, ...rest }) {

  const { currentUser } = useAuth()

  return (

    <Route
      {...rest}
      render={props => {
        return currentUser ? <Component {...props} /> : {/*toast("Please ensure you're signed in.")*/} && <Redirect to="/" />

      }}
    ></Route>
  )
}